$mol_link_source $mol_link
	hint @ \Source code
	sub /
		<= Icon $mol_icon_script_text
